import Vue from 'vue'
import Router from 'vue-router'
import PageNotFound from './views/404.vue'
import store from './store'

/* Layout */
import Layout from '@/layout'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "*",
    //   component: PageNotFound,
    //   meta: {
    //     fullPage: true
    //   }
    // },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/index.vue'),
          name: 'admin',
          meta: {
            requiresAuth: true
          }
        }
      ],
    },
    {
      path: '/customers/manage/:customerId',
      component: Layout,
      children: [
        {
          path: '',
          name: 'CustomerEdit',
          component: function () {
            return import(/* webpackChunkName: "managecustomer" */ './views/admin/manage-customer.vue')
          },
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ],
    },
    {
      path: '/device',
      component: Layout,
      children: [
        {
          path: '',
          name: 'device',
          component: () => import(/* webpackChunkName: "device" */ './views/device/index.vue'),
          meta: {
              requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/device/manage/:deviceId',
      component: Layout,
      children: [
        {
          path: '',
          name: 'DeviceEdit',
          component: () => import(/* webpackChunkName: "managedevice" */ './views/device/manage-device.vue'),
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/launcher/web-form',
      component: Layout,
      children: [
        {
          path: '',
          name: 'WebForm',
          component: () => import(/* webpackChunkName: "web-form" */ './views/launcher/web-form.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/launcher/web-form/:webFormId',
      component: Layout,
      children: [
        {
          path: '',
          name: 'ManageWebForm',
          component: () => import(/* webpackChunkName: "manage-web-form" */ './views/launcher/manage-web-form.vue'),
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/launcher/activation-policy',
      component: Layout,
      children: [
        {
          path: '',
          name: 'ActivationPolicy',
          component: () => import(/* webpackChunkName: "activation-policy" */ './views/launcher/activation-policy.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/launcher/activation-policy/:policyId',
      component: Layout,
      children: [
        {
          path: '',
          name: 'ManageActivationPolicy',
          component: () => import(/* webpackChunkName: "manage-activation-policy" */ './views/launcher/manage-activation-policy.vue'),
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/users',
      component: Layout,
      children: [
        {
          path: '',
          name: 'UserList',
          component: () => import(/* webpackChunkName: "userlist" */ './views/user/user-list.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/users/manage/:userId',
      component: Layout,
      children: [
        {
          path: '',
          name: 'UserEdit',
          component: () => import(/* webpackChunkName: "manageuser" */ './views/user/user-manage.vue'),
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/users/manage',
      component: Layout,
      children: [
        {
          path: '',
          name: 'ManageUser',
          component: () => import(/* webpackChunkName: "manageuser" */ './views/user/user-manage.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/roles',
      component: Layout,
      children: [
        {
          path: '',
          name: 'RoleList',
          component: () => import(/* webpackChunkName: "rolelist" */ './views/user/role-list.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/roles/manage/:roleId',
      component: Layout,
      children: [
        {
          path: '',
          name: 'RoleEdit',
          component: () => import(/* webpackChunkName: "managerole" */ './views/user/role-manage.vue'),
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/roles/manage',
      component: Layout,
      children: [
        {
          path: '',
          name: 'ManageRole',
          component: () => import(/* webpackChunkName: "managerole" */ './views/user/role-manage.vue'),
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/settings/office-city',
      component: Layout,
      children: [
        {
          path: '',
          name: 'OfficeCity',
          component: function () {
            return import(/* webpackChunkName: "office-city" */ './views/setting/office-city.vue')
          },
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/settings/office-country',
      component: Layout,
      children: [
        {
          path: '',
          name: 'OfficeCountry',
          component: function () {
            return import(/* webpackChunkName: "office-country" */ './views/setting/office-country.vue')
          },
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/settings/office-name',
      component: Layout,
      children: [
        {
          path: '',
          name: 'OfficeName',
          component: function () {
            return import(/* webpackChunkName: "office-name" */ './views/setting/office-name.vue')
          },
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/settings/office-department',
      component: Layout,
      children: [
        {
          path: '',
          name: 'Department',
          component: function () {
            return import(/* webpackChunkName: "department" */ './views/setting/office-department.vue')
          },
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/settings/sr-country',
      component: Layout,
      children: [
        {
          path: '',
          name: 'SRCountry',
          component: function () {
            return import(/* webpackChunkName: "sr-country" */ './views/setting/sr-country.vue')
          },
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/settings/preference',
      component: Layout,
      children: [
        {
          path: '',
          name: 'Preference',
          component: function () {
            return import(/* webpackChunkName: "preference" */ './views/setting/preference.vue')
          },
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: function () {
          return import(/* webpackChunkName: "login" */ './views/Login.vue')
      },
      meta: {
        guest: true
      }
    },
    {
      path: '/404',
      component: PageNotFound,
      hidden: true
    },
    { path: '*', redirect: '/404', hidden: true }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // TODO: change to vuex?
    if (!store.getters.loggedIn) {
      next({
        path: '/login',
        params: {nextUrl: to.fullPath}
      })
    } else {
      // TODO: handle privileges here
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!store.getters.loggedIn) {
      next()
    } else {
      next({name: 'home'})
    }
  } else {
    next()
  }
})

export default router
